import log, { LogLevelDesc } from 'loglevel';

const logLevel: LogLevelDesc = (process.env.LOG_LEVEL as LogLevelDesc) || 'error';
log.setLevel(logLevel);

export default log;
